import PropTypes from "prop-types"
import React from "react"

const IconRow = ({ icon, children }) => (
  <div className="flex items-start space-x-3">
    <i className={`${icon} mt-1 text-teal-600`} />
    <div className="flex flex-col">{children}</div>
  </div>
)

IconRow.propTypes = {
  icon: PropTypes.string.isRequired,
  children: PropTypes.node,
}

const DetailRow = ({ icon, label, children }) => (
  <IconRow icon={icon}>
    <span className="font-semibold text-gray-900">{label}</span>
    <span className="text-gray-700">{children}</span>
  </IconRow>
)

DetailRow.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
}

const paymentMethodDisplay = (copy, paymentMethod, paymentMethods) => {
  if (paymentMethod === "manual") return copy.cashPaymentMethod

  const selected = paymentMethods.find(
    (pm) => pm.stripePaymentMethodId === paymentMethod
  )

  if (!selected) return null

  return (
    <>
      <span className="block">{selected.title}</span>
      {selected.subtitle && (
        <span className="block text-sm text-gray-600">{selected.subtitle}</span>
      )}
    </>
  )
}

const DetailsCard = ({ copy, state, billingStart, registrationRequired }) => {
  const { requiredInformation, paymentMethod, paymentMethods } = state
  const insuranceCompanyName = requiredInformation?.insurance?.companyName
  const registration = requiredInformation?.registration
  const registrationNumber = registration?.registrationNumber

  return (
    <div>
      <h4 className="mb-2 mt-0 font-semibold text-gray-700">{copy.details}</h4>
      <div className="flex flex-col space-y-4 rounded-lg border border-gray-300 px-4 py-6">
        {insuranceCompanyName && (
          <DetailRow icon="fa-solid fa-shield-check" label={copy.insurance}>
            {insuranceCompanyName}
          </DetailRow>
        )}
        {registrationRequired && registrationNumber && (
          <DetailRow icon="fa-solid fa-id-card" label={copy.registration}>
            {registrationNumber}
          </DetailRow>
        )}
        <DetailRow icon="fa-solid fa-credit-card" label={copy.paymentMethod}>
          {paymentMethodDisplay(copy, paymentMethod, paymentMethods)}
        </DetailRow>
        <IconRow icon="fa-solid fa-calendar-days">
          <span className="text-gray-700">{billingStart.copy}</span>
        </IconRow>
      </div>
    </div>
  )
}

DetailsCard.propTypes = {
  copy: PropTypes.shape({
    details: PropTypes.string.isRequired,
    insurance: PropTypes.string.isRequired,
    paymentMethod: PropTypes.string.isRequired,
    cashPaymentMethod: PropTypes.string.isRequired,
    registration: PropTypes.string,
  }).isRequired,
  state: PropTypes.shape({
    paymentMethod: PropTypes.string,
    paymentMethods: PropTypes.arrayOf(
      PropTypes.shape({
        stripePaymentMethodId: PropTypes.string.isRequired,
        title: PropTypes.string,
        subtitle: PropTypes.string,
      })
    ),
    requiredInformation: PropTypes.shape({
      insurance: PropTypes.shape({
        companyName: PropTypes.string,
      }),
      registration: PropTypes.shape({
        registrationNumber: PropTypes.string,
      }),
    }),
  }).isRequired,
  billingStart: PropTypes.shape({
    copy: PropTypes.string.isRequired,
  }).isRequired,
  registrationRequired: PropTypes.bool,
}

export default DetailsCard
